import { RebalancingProposalEntity } from './rebalancing-proposal.entity';

export class RebalancingProposalGroupEntity {
  public teamId!: string;
  public teamName!: string;
  public proposals!: RebalancingProposalEntity[];
}
